<template id="StarIcon">
  <span v-b-tooltip.hover title="Number of Stars" class="fa fa-star" />
</template>

<script>
export default {
  name: "StarIcon",
};
</script>
